import { OnBaseDocumentData } from '../types/OnBaseDocumentData';
import { EventHandler, MouseEventHandler, useEffect, useState } from 'react';
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import ViewOnBaseDocumentModal from './ViewOnBaseDocumentModal';
import useGetOnBaseDocuments from '../hooks/useGetOnBaseDocuments';
import { GetOnBaseDocumentsRequest } from '../types/GetOnBaseDocumentsRequest';
import '../../../styles/dashboardStyles.css';

interface props {
  DataList: OnBaseDocumentData[],
  handleUnDeleteDocument: any
}

function OnBaseDeletedDocumentsTable({ DataList, handleUnDeleteDocument}: props) {

    const formatted_data =  DataList?.map(item => ({
        ...item,
        memberFullName: item.firstName + ' ' + item.lastName,
        }));

  function UnDelete(doc: OnBaseDocumentData)
  {
      handleUnDeleteDocument(doc);
  }

  const ButtonsTemplate= (rowData: OnBaseDocumentData, column: any) => { 
    return (<div>
        <button style={{ margin: "2px" }} onClick={()=> UndeleteClick(rowData)}>Undelete</button>
    </div>)
  };

  const UndeleteClick = (rowData: OnBaseDocumentData) => {
    if (confirm(`Are you sure you want to UN-DELETE document ${rowData.documentName}?`))
      UnDelete(rowData)
  }

  return (
    <>
     <div className="data-table-section p-grid">
      <DataTable value={formatted_data} stripedRows >
        <Column field='rowKey' header='RowKey' style={{ display: 'none' }}></Column>
        <Column field='partitionKey' header='PartitionKey' style={{ display: 'none' }}></Column>
        <Column field='blobUrl' header='BlobUrl' style={{ display: 'none' }}></Column>
        <Column field='documentTypeId' header='DocumentTypeId' style={{ display: 'none' }}></Column>
        <Column field='documentName' header='Document Name' ></Column>
        <Column field='onBaseDocumentTypeName' header='Doc Type' ></Column>
        <Column field='memberFullName' header='Member'></Column>        
        <Column field='benesysAltId' header='Member ID' ></Column>
        <Column field='client' header='Client' ></Column>
        <Column field='onBaseAttemptNumber' header='Attempts' ></Column>
        <Column field='supportNotificationSent' header='Support' ></Column>
        <Column field="ButtonsTemplate" header="Actions" style={{width: "23em"}} body={ButtonsTemplate} />
      </DataTable>
      </div>
  
    </>
  )
}

export default OnBaseDeletedDocumentsTable;